import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import RolesAdd from "../screens/masters/Roles/RolesAdd";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/roles-list", name: "Roles" },
  { link: "/roles-add", name: "Add Roles" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <RolesAdd />
    </LayoutContainer>
  </>
);

export default Home;
